import { Navigate, Outlet, useLocation } from "react-router-dom";
import BusyIndicatorHTML from "../components/BusyIndicator/BusyIndicatorHTML";
import { RoutePath } from "../constants/RoutePath";
import { useAuth } from "./useAuth";

export default function RequireAuthentication() {
  const location = useLocation();
  const { state } = useAuth();

  if (!state.IsInitialized) {
    return (
      <BusyIndicatorHTML
        isOpen
        mode="overlay"
        message="Restoring your session..."
      />
    );
  }

  if (!state.IsAuthenticated) {
    return <Navigate to={RoutePath.Login} replace state={{ from: location }} />;
  }

  return <Outlet />;
}
